import { ConstantsProps } from './types';

const CONSTANTS: ConstantsProps = {
  ROUTE_KEYS: {
    WORKFLOWS_PLUGIN_SCREEN: 'workflows-plugin-screen',
  },
  ASSET_TYPES: {
    LOGOS: 'logos',
  },
  ASSET_NAMES: {
    LOGO_RECTANGLE: 'logo-rectangle.png',
    LOGO_SQUARE: 'logo-square.png'
  },
  LOCAL_STORAGE: {
    ACCESS_TOKEN: 'access_token',
    REFRESH_TOKEN: 'refresh_token'
  },
  ERROR_CODES: {
    REFRESH_TOKEN_FAILED: 'refresh_token_failed',
    NO_PUBLIC_KEY: 'no_public_key',
    BAD_CREDENTIALS: 'bad_credentials',
    MAX_UNSUCCESSFUL_ATTEMPTS: 'max_unsuccessful_logins_attempts',
  },
  MENU_APP_SOURCES: {
    WORKFLOW: 'WORKFLOW',
    CUSTOM_FLOW: 'CUSTOM_FLOW',
  },
  WORKFLOWS_STORE_KEYS: {
    HISTORY: 'history'
  }
}

export default CONSTANTS;